import { Component, Input, EventEmitter, Output } from '@angular/core';
import { User } from '@app/core/models/user/user.model';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/store.states';
import { LogOut } from '@app/store/auth/auth.actions';

@Component({
  selector: 'app-side-nav-menu',
  templateUrl: './side-nav-menu.component.html',
  styleUrls: ['./side-nav-menu.component.scss'],
})
export class SideNavMenuComponent {
  isSubMenuOpen = false;

  @Input() isOpen = false;

  @Input() links: any;

  @Input() currentUser: User;

  @Output() handleClose = new EventEmitter<void>();

  subMenu = null;

  constructor(private readonly store: Store<AppState>) {}

  closeMenu() {
    this.handleClose.emit();
  }

  closeSubMenu() {
    this.subMenu = null;
  }

  logOut() {
    this.store.dispatch(new LogOut());
  }

  toggleSubMenu(event: Event, link) {
    event.stopPropagation();

    this.subMenu = {
      title: link.title,
      links: link.children,
    };
  }
}
